import { Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';

import { useI18n } from '../lib/i18n/hooks';
import { LANGUAGES, type SupportedLanguage } from '../lib/i18n/languages';

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { currentLanguage, changeLanguage } = useI18n();

  const currentLang = LANGUAGES.find((lang) => lang.code === currentLanguage);

  return (
    <Menu positioning="below-end">
      <MenuTrigger disableButtonEnhancement>
        <MenuButton appearance="subtle" className={className}>
          {currentLang?.name}
        </MenuButton>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          {LANGUAGES.map((lang) => (
            <MenuItem key={lang.code} onClick={() => changeLanguage(lang.code as SupportedLanguage)}>
              {lang.name}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
